    const collapsedPopUp = document.getElementById('collapsible-popup_wrapper');
    const learnMoreButn = document.getElementById('collapsible-popup_learnMore');
    const closePopUp = document.getElementById('xbutton');


    learnMoreButn.addEventListener('click', function(){
    collapsedPopUp.classList.add('collapsible-popup_active');
    });

        closePopUp.addEventListener('click', function(){
    collapsedPopUp.classList.remove('collapsible-popup_active');
    });


    function triggerPopUp(){
    collapsedPopUp.classList.add('collapsible-popup_active');
    }

setTimeout(triggerPopUp, 3000);